import React, { ReactNode } from 'react';

const Single = ({ children, ...props }: { children: ReactNode }) => (
  <div className="flex flex-col w-[35%] md:w-full md:max-w-[240px] flex-shrink-0" {...props}>
    {children}
  </div>
);

export default Single;
